import { ChangeDetectionStrategy, Component, inject, viewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { signal } from '@angular/core';
import { FormsModule, NgModel } from '@angular/forms';
import { AppAutofocusDirective } from "../../../../shared/directives/appAutofocus.directive";
import { AuthService } from '../../../../shared/services/auth.service';
import { firstValueFrom } from 'rxjs';
import { ProblemDetails } from "../../../../shared/components/problem-details/problem-details";
import { MessagingService } from '../../../../shared/services/messaging.service';
import { ToastMessageService } from '../../../../shared/services/toast-message.service';

@Component({
  selector: 'app-forgot-password-dialog',
  templateUrl: './forgot-password-dialog.html',
  styleUrl: './forgot-password-dialog.scss',
  imports: [FormsModule, AppAutofocusDirective, ProblemDetails],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForgotPasswordDialog {
  constructor(public activeModal: NgbActiveModal) { }

  readonly username = signal('');
  readonly token = signal('');
  readonly messagesService = inject(MessagingService);
  close(result = false): void {
    this.activeModal.close(result);
  }

  readonly userForm = viewChild.required<NgModel>('userForm');
  readonly tokenForm = viewChild.required<NgModel>('tokenForm');

  readonly auth = inject(AuthService);
  readonly toasts = inject(ToastMessageService);
  readonly telefonoEmail = signal('');
  readonly tokenSent = signal(false);
  readonly focusOnCode = signal(false);

  async sendToken() {
    this.messagesService.validationErrors.set(null);
    if (!this.userForm().valid) {
      return;
    }

    await firstValueFrom(this.auth.passwordResetGetToken(this.username(), this.telefonoEmail()));
    this.toasts.showSuccess('Se ha enviado un código de verificación a su correo electrónico o teléfono.');
    this.tokenSent.set(true);
    setTimeout(() => {
      this.focusOnCode.set(true);
    }, 1000);
  }

  async validateToken() {
    await firstValueFrom(this.auth.validateToken(this.username(), this.token()));
    this.close(true);
  }

}
